export enum QuintsApiLinkValues {
  AFFILIATE = 'affiliate_link',
  TRACKERS = 'tracker_link',
}
